var lx = lx || {};
lx.object = lx.object || {};

/* ex objectParValForm function*/
lx.object.parValForm = function (pIps, pIpv, pTsk, pThis) {
    $(".lx-parValForm").remove();//vsm-parValForm
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=objectParValForm",
            x01: pIps,
            x02: pIpv,
            x03: pTsk
        },
        success: function (d) {
            $(d).dialog({
                modal: true,
                resizable: false,
                width: 410
            });
        }
    });
};

/* ex objectParValSubmit function*/
lx.object.parValSubmit = function (pThis) {
    var vConfirm;
    if ($v("P_OPV_ID") > 0) vConfirm = confirm('This parameter has been sumbitted, are you sure you want to override previous value?');
    else vConfirm = confirm('Are you sure you want to submit this value?');
    if (vConfirm) {
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=objectParValSubmit",
                x01: $v("P_VALUE"),
                x02: $v("P_OPV_ID"),
                x03: $v("P_OPS_ID"),
                x04: $v("P_TSK_ID")
            },
            success: function (d) {
                if (d.trim() == 'CL') alert('Entered value is smaller then previous Value, please review your entry!')
                else {
                    $(".lx-parValForm").dialog("close");
                    if ($v("pFlowStepId") == 470) lx.oldir.refresh();
                    else if ($v("pFlowStepId") == 28) lxTaskList($v("P28_VOYAGE_ID"));
                    else if ($v("pFlowStepId") == 96) location.reload();
                }
            }
        });
    }
};